import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "chat-header" }
const _hoisted_2 = { class: "actions" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Burger = _resolveComponent("Burger")
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$responsive.mobile)
        ? (_openBlock(), _createBlock(_component_Burger, { key: 0 }))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_3, [
        ($options.new_btn)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "new-chat",
              onClick: _cache[0] || (_cache[0] = $event => ($options.onNewChat()))
            }, [
              _createVNode(_component_IconAsButton, {
                icon: "edit-05",
                stroke: "var(--brand-700)",
                size: "1.6rem"
              }),
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text" }, " New ", -1 /* HOISTED */))
            ]))
          : _createCommentVNode("v-if", true),
        ($props.canShare)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["share-open", {pointer: !$props.generating}]),
              disabled: $props.generating,
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('share')))
            }, [
              _createVNode(_component_Icon, {
                icon: $props.shared ? 'globe-02' : 'share-01',
                stroke: $props.shared ? 'var(--success-600)' : 'var(--brand-700)',
                size: "1.6rem"
              }, null, 8 /* PROPS */, ["icon", "stroke"]),
              _createElementVNode("span", _hoisted_5, _toDisplayString($props.shared ? 'Shared' : 'Share'), 1 /* TEXT */)
            ], 10 /* CLASS, PROPS */, _hoisted_4))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}